import * as React from 'react';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import { ResponsivePicture } from '../../ReactComponents/ResponsivePicture/ResponsivePicture';
import TouchSwiper from '../../ReactComponents/TouchSwiper/TouchSwiper';
import { BrandListProps } from './BrandListProps.csharp';

export const BrandList = (props: BrandListProps) => {
    return (
        <div className={`BrandList ${BlockSectionClassResolver.Resolve(props.model.blockSectionMargin)}`}>
            <div className="BrandList__Content">
                <ul className="BrandList__Items">
                    <TouchSwiper>
                        {props.model.brands.map((brand, i) => (
                            <li className="BrandList__Item" key={i}>
                                <a className="BrandList__Link" href={brand.url}>
                                    <ResponsivePicture profile={props.profile} model={brand.image} />
                                </a>
                            </li>
                        ))}
                        {props.model.seeMoreLink?.href && (
                            <a href={props.model.seeMoreLink.href} target={props.model.seeMoreLink.target} className="BrandList__BrandsPageLink hideOnDesktop">
                                {props.model.seeMoreLink.text}
                            </a>
                        )}
                    </TouchSwiper>
                </ul>
                {props.model.seeMoreLink?.href && (
                    <a href={props.model.seeMoreLink.href} target={props.model.seeMoreLink.target} className="BrandList__BrandsPageLink hideOnMobile">
                        {props.model.seeMoreLink.text}
                    </a>
                )}
            </div>
        </div>
    );
};
